import SearchOptions from "datalign-module-template/models/search-options";
import React from "react";
import NTSortBy from "./nt-sort-by";
import BaseSortBy from "./base-sort-by";

const SortBy = ({
  searchOptions,
  onOptionsChange,
}: {
  searchOptions: SearchOptions;
  onOptionsChange: (searchOptions: SearchOptions) => void;
}) => {
  return ["FAF-nt"].includes(process.env.REACT_APP_STYLING_THEME ?? "") ? (
    <NTSortBy searchOptions={searchOptions} onOptionsChange={onOptionsChange} />
  ) : (
    <BaseSortBy
      searchOptions={searchOptions}
      onOptionsChange={onOptionsChange}
    />
  );
};

export default SortBy;
